import { useEffect, useState } from 'react';
import { parseBoardRoute } from '@ringring/core';
import { Board, boardKeyFor } from './Board';
import { Dashboard } from './Dashboard';
import { Home } from './Home';
import { Setup } from './Setup';
import { SignIn } from './SignIn';
import { Staff } from './Staff';
import { useLang } from './lang';

function useHash(): string {
  const [hash, setHash] = useState(window.location.hash);
  useEffect(() => {
    const on = () => setHash(window.location.hash);
    window.addEventListener('hashchange', on);
    return () => window.removeEventListener('hashchange', on);
  }, []);
  return hash;
}

// Hash routes: #/ (landing), #/signin, #/setup (first setup), #/orgs/:org/venues/new (owner adds a venue),
// #/dashboard and #/dashboard/:venue (the shell with the venue switcher), #/dashboard/:venue/settings (the venue
// settings, issue #11), #/staff/:pp, #/board/:pp?key=<board key> (the TV board's signed link, issue #16).
export function App() {
  const hash = useHash();
  const [lang, setLang] = useLang();
  const staff = /^#\/staff\/([^/?]+)/.exec(hash);
  if (staff) return <Staff pickupPointId={decodeURIComponent(staff[1])} lang={lang} setLang={setLang} />;
  const board = parseBoardRoute(hash);
  if (board) return <Board pickupPointId={board.pickupPointId} boardKey={boardKeyFor(board.pickupPointId, board.key)} lang={lang} />;
  if (/^#\/signin/.test(hash)) {
    return <SignIn lang={lang} setLang={setLang} onSignedIn={(me) => (window.location.hash = me.venues.length > 0 ? '#/dashboard' : '#/setup')} />;
  }
  if (/^#\/setup/.test(hash)) return <Setup lang={lang} setLang={setLang} />;
  const newVenue = /^#\/orgs\/([^/?]+)\/venues\/new/.exec(hash);
  if (newVenue) return <Setup lang={lang} setLang={setLang} orgId={decodeURIComponent(newVenue[1])} />;
  const dashboard = /^#\/(?:dashboard|account)(?:\/([^/?]+))?(?:\/(settings|feedback))?/.exec(hash);
  if (dashboard) return <Dashboard lang={lang} setLang={setLang} venueId={dashboard[1] ? decodeURIComponent(dashboard[1]) : null} page={dashboard[2] === 'settings' || dashboard[2] === 'feedback' ? dashboard[2] : 'home'} />;
  return <Home lang={lang} setLang={setLang} />;
}
